module.exports = __webpack_public_path__ + "../static/media/formato2 - copia.9f4c8b31.jpg";